<script lang="ts" setup>
import { computed, type PropType } from 'vue'
import { mdIconMap, type MdIconType } from '@/utils/icon.ts'

const props = defineProps({
  type: {
    type: String as PropType<MdIconType>,
    default: 'mdiHelpCircleOutline'
  },
  size: {
    type: String,
    default: 'base',
    validator: (value: string) =>
      ['xs', 'sm', 'base', 'lg', 'xl', '2xl'].includes(value)
  }
})

const dimensions = computed(() => {
  const rootElement = document.querySelector(':root')
  if (!rootElement) return { width: 16, height: 16 }
  const rootStyles = getComputedStyle(rootElement)
  const rootSize = parseInt(rootStyles.fontSize)
  const baseSize = rootSize + (parseInt(rootStyles.lineHeight) - rootSize) / 2

  let pixelSize
  switch (props.size) {
    case 'xs':
      pixelSize = 0.75 * baseSize
      break
    case 'sm':
      pixelSize = 0.875 * baseSize
      break
    case 'base':
      pixelSize = baseSize
      break
    case 'lg':
      pixelSize = 1.125 * baseSize
      break
    case 'xl':
      pixelSize = 1.25 * baseSize
      break
    case '2xl':
      pixelSize = 1.5 * baseSize
      break
    default:
      pixelSize = baseSize
      break
  }

  return {
    width: Math.floor(pixelSize),
    height: Math.floor(pixelSize)
  }
})

const svgPath = computed(() => {
  return mdIconMap[props.type] || mdIconMap.mdiHelpCircleOutline
})
</script>

<template>
  <i :class="['inline-block', { 'cursor-pointer': $attrs.onClick }]">
    <svg
      viewBox="0 0 24 24"
      :width="dimensions.width"
      :height="dimensions.height"
    >
      <path :d="svgPath" fill="currentColor" />
    </svg>
  </i>
</template>
